export function getBasename(url: string) {
  if (url) {
    var pathname = new URL(url).pathname;
    var parts = pathname.split('/');
    return parts[parts.length - 1];
  }
  return url;
}

export function getCurrency(num: number, negative = false, localization: string = 'en-US') {
  if (num) {
    const numberFormatter = Intl.NumberFormat(localization);
    let formatted = numberFormatter.format(num);
    formatted = negative === true && formatted !== '0' ? '-' + formatted : formatted;
    return formatted;
  }
  return num;
}

export function formatDate(date: Date) {
  var d = date,
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('/');
}

// export function getDateString(date: Date) {
//   var d = date,
//     month = '' + (d.getMonth() + 1),
//     day = '' + d.getDate(),
//     year = d.getFullYear();
//   return [year, month, day].join('');
// }

export function svgToDataURL(svgString: string) {
  const encodedData = encodeURIComponent(svgString);
  return `data:image/svg+xml;charset=utf-8,${encodedData}`;
}

export function hasScroll(element: HTMLElement) {
  // check has vertical scroll
  const hasVerticalScroll = element.scrollHeight > element.clientHeight;

  // check has horizontal scroll
  const hasHorizontalScroll = element.scrollWidth > element.clientWidth;

  return {
    vertical: hasVerticalScroll,
    horizontal: hasHorizontalScroll,
  };
}

export function getScrollbarWidth() {
  // Tạo một div tạm thời
  const div = document.createElement('div');
  div.style.position = 'absolute';
  div.style.top = '-9999px';
  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll'; // Bắt buộc để hiển thị thanh cuộn
  div.style.visibility = 'hidden';

  document.body.appendChild(div);

  // Tính toán chiều rộng thanh cuộn
  const scrollbarWidth = div.offsetWidth - div.clientWidth;

  // Xóa div tạm thời
  document.body.removeChild(div);

  return scrollbarWidth;
}

export function escapeCsvValue(value: string) {
  if (value == null) return '';

  let str = String(value);

  // prevent tab
  str = str.replace(/\t/g, ' ');

  let needsQuote = false;

  // pos_cd
  if (str.startsWith('pos_cd:')) {
    str = str.replace('pos_cd:', '');
    return `"${str}"`;
  }

  // 数式誤認識防止 (formula start)
  if (/^([=+])/.test(str)) {
    needsQuote = true;
  }

  // 特殊記号時のダブルクオート追加
  if (/[,"\r\n@¥$%#]/.test(str)) {
    needsQuote = true;
  }

  if (needsQuote) {
    // escape internal "
    str = str.replace(/"/g, '""');
    return `"${str}"`;
  }

  return str;
}

export function exportToCsvFile(filename: string, rows: string[][], columns: string[] = []) {
  const BOM = '\uFEFF';

  const csvRows = [...rows.map((row) => row.map(escapeCsvValue).join(','))];
  if (columns.length > 0) {
    csvRows.unshift(columns.map(escapeCsvValue).join(','));
  }

  const csvString = csvRows.join('\r\n');
  const finalCsv = BOM + csvString;

  const blob = new Blob([finalCsv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function isEditModeAPI(pathname: string) {
  // black list
  const regex = new RegExp(
    '^(' +
      [
        '/login',
        '/permissions',
        '/logout',
        '/companies-login',
        '/check-is-editmode',

        '/deliveries',
        '/delivery-details/\\d+',
        '/delivery',
        '/workflow-actions',
        '/workflow-action',
        '/delivery-update-status',
        '/delivery-detail-update-status',
        '/test-reflection-delivery',
        '/check-approved-delivery',
        '/check-db-version',
        '/database-backup',
        '/download-backup',
        '/schema-check',
        '/auto-restore',
        '/restore/async',
        '/restore/async/status/[^/]+',
        '/restore/async/cancel/[^/]+',
        '/restore/system/status',
      ].join('|') +
      ')$'
  );

  return !regex.test(pathname);
}
